<div class="container">

    <header class="contract-page-header">
        <div class="contract-page-header-inner">
            <div class="contract-page-header-logo">
                <img *ngIf="projectLogo" [src]="projectLogo" alt="Logo" class="contract-logo-img">
                <mat-icon *ngIf="!projectLogo">description</mat-icon>
            </div>
            <div class="contract-page-header-info">
                <h1 class="contract-page-title">{{ model?.name || 'Contract' }}</h1>
                <p class="contract-page-subtitle" *ngIf="currentSigner">
                    Signer: {{ currentSigner?.name || currentSigner?.email || currentSigner?.id }}
                </p>
                <p class="contract-page-subtitle" *ngIf="!currentSigner && model?.name">
                    Complete the form fields to continue
                </p>
            </div>
            <ng-container *ngIf="completed">
                <button mat-stroked-button (click)="backToForm()" class="header-back-btn">
                    <mat-icon>edit</mat-icon>
                    <span>Edit form</span>
                </button>
                <button *ngIf="model?.pdf" mat-stroked-button [disabled]="downloadingPdf" (click)="downloadPdf()" class="header-download-btn">
                    <mat-icon>download</mat-icon>
                    <span *ngIf="!downloadingPdf">Download PDF</span>
                    <span *ngIf="downloadingPdf">Generating...</span>
                </button>
                <div class="contract-page-header-badge">
                    <mat-icon class="badge-icon">check_circle</mat-icon>
                    <span>Completed</span>
                </div>
            </ng-container>
        </div>
    </header>

    <div class="message error" *ngIf="loadError">{{ loadError }}</div>

    <div *ngIf="!loadError && viewMode === 'FORM'" class="wizard-container">
        <div class="form-progress-section" *ngIf="pagesWithFormGroups.length > 0">
            <div class="progress-label">
                <span>Step {{ currentStepIndex + 1 }} of {{ pagesWithFormGroups.length }}</span>
            </div>
            <div class="simple-progress-bar">
                <div class="simple-progress-fill" [style.width.%]="getProgress()"></div>
            </div>
        </div>
        <div class="wizard-card form-card" *ngIf="pagesWithFormGroups[currentStepIndex] as pageGroup">
            <div class="card-header">
                <h2 class="form-card-title">Page {{ pageGroup.page }}</h2>
                <p class="form-card-subtitle">Complete the fields below to continue.</p>
            </div>

            <div class="card-body">
                <div class="dynamic-form-grid">
                    <div *ngFor="let field of pageGroup.independentFields" 
                         [class.full-width]="isFullWidth(field)" 
                         class="form-field-wrapper">
                        <ng-container *ngTemplateOutlet="fieldTemplate; context: { $implicit: field }"></ng-container>
                    </div>
                    <div *ngFor="let table of pageGroup.tables" class="full-width table-group-card">
                        <h4 class="table-group-title">{{ table.name }}</h4>
                        <div class="table-scroll-container">
                            <table class="contract-form-table">
                                <thead>
                                    <tr>
                                        <th *ngFor="let col of table.columns">{{ col.name }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td *ngFor="let col of table.columns" class="table-col-fields">
                                            <div *ngFor="let field of col.fields" class="table-field-row">
                                                <ng-container *ngTemplateOutlet="fieldTemplate; context: { $implicit: field, hideLabel: true }"></ng-container>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button mat-stroked-button class="btn-ghost" *ngIf="isEmployee" (click)="saveAndExit()">Save and exit</button>
                <div class="nav-buttons">
                    <button mat-stroked-button *ngIf="currentStepIndex > 0" class="btn-secondary" (click)="prevStep()">Back</button>
                    <button mat-flat-button color="primary" class="btn-primary" [disabled]="loading" (click)="nextStep()">
                      <span *ngIf="!loading">{{ isLastStep ? 'Finish Form' : 'Continue' }}</span>
                      <span *ngIf="loading">{{ isLastStep ? 'Saving...' : 'Validating...' }}</span>
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="pagesWithFormGroups.length === 0" class="wizard-card empty-card text-center">
            <h3>No fields available</h3>
            <p>You can proceed to finish the document.</p>
            <button mat-flat-button color="primary" class="btn-primary" (click)="finishForm()">Finish Document</button>
        </div>


        <ng-template #fieldTemplate let-field let-hideLabel="hideLabel">
            <div class="modern-field-container">
                <label *ngIf="!hideLabel && field.type !== ContractFieldType.HEADERS"
                       class="modern-field-label"
                       [matTooltip]="fieldLabelTooltip(field)"
                       matTooltipPosition="above">
                    {{ truncatedFieldLabel(field) }} <span *ngIf="field.required" class="required-marker">*</span>
                </label>
                
                <ng-container [ngSwitch]="field.type">
                    
                    <h1 *ngSwitchCase="ContractFieldType.HEADERS" class="field-header-title">
                        {{ field.value || field.name || 'Title' }}
                    </h1>

                    <div *ngSwitchCase="ContractFieldType.TEXT" class="modern-input-wrapper">
                        <input class="modern-input" [(ngModel)]="field.value" (blur)="saveProgress()" [placeholder]="field.placeholder || ''"
                               [required]="field.required"
                               [pattern]="field.validation?.pattern"
                               [maxlength]="field.validation?.maxLength || null" [minlength]="field.validation?.minLength || null">
                    </div>

                    <div *ngSwitchCase="ContractFieldType.DATE" class="modern-input-wrapper">
                        <input class="modern-input" type="date" [(ngModel)]="field.value" (blur)="saveProgress()" [required]="field.required">
                    </div>

                    <div *ngSwitchCase="ContractFieldType.NUMBER" class="modern-input-wrapper">
                        <input class="modern-input" type="text" inputmode="numeric"
                               [ngModel]="field.value || ''"
                               (ngModelChange)="field.value = $event"
                               (input)="onNumberInput(field, $event)"
                               (blur)="onNumberBlur(field)"
                               [required]="field.required"
                               [placeholder]="field.placeholder || '0'">
                    </div>

                    <div *ngSwitchCase="ContractFieldType.TEXTAREA" class="modern-input-wrapper">
                        <textarea class="modern-input modern-textarea"
                                  [ngModel]="field.value || ''"
                                  (ngModelChange)="field.value = $event"
                                  (blur)="saveProgress()"
                                  [required]="field.required"
                                  [pattern]="field.validation?.pattern"
                                  [placeholder]="field.placeholder || ''"
                                  [maxlength]="field.validation?.maxLength || null"
                                  [minlength]="field.validation?.minLength || null"></textarea>
                    </div>

                    <div *ngSwitchCase="ContractFieldType.EMAIL" class="modern-input-wrapper">
                        <input class="modern-input" type="email" [(ngModel)]="field.value" (blur)="saveProgress()"
                               [required]="field.required" [pattern]="field.validation?.pattern || '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'"
                               [placeholder]="field.placeholder || 'email@example.com'"
                               [maxlength]="field.validation?.maxLength || null" [minlength]="field.validation?.minLength || null">
                    </div>

                    <div *ngSwitchCase="ContractFieldType.PHONE" class="modern-input-wrapper">
                        <input class="modern-input" type="tel" [(ngModel)]="field.value" (blur)="saveProgress()"
                               [required]="field.required" [pattern]="field.validation?.pattern"
                               [placeholder]="field.placeholder || ''"
                               [maxlength]="field.validation?.maxLength || null" [minlength]="field.validation?.minLength || null">
                    </div>

                    <div *ngSwitchCase="ContractFieldType.DROPDOWN" class="modern-input-wrapper">
                        <select *ngIf="field.options?.length; else dropdownNoOpts" [(ngModel)]="field.value" (change)="saveProgress()"
                            class="modern-input select-input">
                            <option value="">-- Select --</option>
                            <option *ngFor="let opt of field.options" [value]="opt">{{opt}}</option>
                        </select>
                        <ng-template #dropdownNoOpts>
                            <p class="no-options-hint">No options configured.</p>
                        </ng-template>
                    </div>

                    <div *ngSwitchCase="ContractFieldType.CHECKBOX" class="modern-checkbox-list">
                        <ng-container *ngIf="field.groupKey; else singleCheckbox">
                            <div class="checkbox-group">
                                <div *ngFor="let opt of field.options" class="modern-checkbox-label">
                                    <input type="checkbox"
                                           [checked]="isOptionChecked(field, opt)"
                                           (change)="toggleOption(field, opt)"
                                           class="modern-checkbox">
                                    <span>{{ opt }}</span>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #singleCheckbox>
                            <div class="modern-checkbox-label">
                                <input type="checkbox" 
                                       [ngModel]="field.value === 'checked'" 
                                       (ngModelChange)="field.value = $event ? 'checked' : ''; saveProgress()" 
                                       class="modern-checkbox">
                                <span *ngIf="!hideLabel">{{ field.name || 'Accept' }}</span>
                            </div>
                        </ng-template>
                    </div>

                    <div *ngSwitchCase="ContractFieldType.RADIO" class="modern-radio-list">
                        <div class="radio-group">
                            <div *ngFor="let opt of field.options" class="modern-radio-label">
                                <input type="radio" [name]="field.id" [value]="opt" [(ngModel)]="field.value" (change)="toggleRadio(field, field.value)" class="modern-radio">
                                <span>{{opt}}</span>
                            </div>
                        </div>
                    </div>

                    <div *ngSwitchCase="ContractFieldType.SIGNATURE" class="signature-box modern-box" (click)="interactWithField(field)">
                        <img *ngIf="field.value" [src]="field.value" class="signature-img">
                        <div *ngIf="!field.value" class="box-placeholder"><mat-icon>draw</mat-icon> <span>Click to sign</span></div>
                    </div>

                    <div *ngSwitchCase="ContractFieldType.INITIALS" class="initials-box modern-box" (click)="interactWithField(field)">
                        <img *ngIf="field.value" [src]="field.value" class="initials-img">
                        <div *ngIf="!field.value" class="box-placeholder"><mat-icon>text_fields</mat-icon> <span>Click for initials</span></div>
                    </div>

                    <div *ngSwitchCase="ContractFieldType.FILE" class="modern-input-wrapper file-field-wrapper">
                        <div *ngIf="field.value" class="file-field-preview">
                            <ng-container *ngIf="field.value.includes('application%2Fpdf') || field.value.toLowerCase().split('?')[0].includes('.pdf'); else fileImgPreview">
                                <mat-icon class="file-icon">picture_as_pdf</mat-icon>
                                <a [href]="field.value" target="_blank" class="file-field-link">View PDF</a>
                            </ng-container>
                            <ng-template #fileImgPreview>
                                <img [src]="field.value" class="file-field-img-preview">
                            </ng-template>
                            <button mat-icon-button (click)="field.value = ''; saveProgress()" [disabled]="loading" class="file-remove-btn" type="button">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                        <label *ngIf="!field.value" class="file-upload-label">
                            <mat-icon>upload_file</mat-icon>
                            <span>{{ loading ? 'Uploading...' : 'Select file (image or PDF)' }}</span>
                            <input type="file" accept="image/*,application/pdf" (change)="onFieldFileSelected($event, field)" [disabled]="loading" style="display:none">
                        </label>
                    </div>

                    <div *ngSwitchDefault class="modern-input-wrapper">
                        <input class="modern-input" [(ngModel)]="field.value" (blur)="saveProgress()" placeholder="Enter value...">
                    </div>

                </ng-container>
            </div>
        </ng-template>
    </div>

    <div class="pdf-wrapper pdf-container" *ngIf="!loadError && model?.pdf && viewMode === 'PDF'">

        <div class="pdf-scroll-viewport">
            <div class="pdf-content pdf-canvas-host" 
                 [style.width.px]="pdfWidth"
                 [style.height.px]="pdfHeight">
                <pdf-viewer [src]="model.pdf"
                            [render-text]="true"
                            [original-size]="false"
                            [autoresize]="true"
                            class="pdf-viewer-native" 
                            (page-rendered)="onPageRendered($event)"
                            (error)="onError($event)"
                ></pdf-viewer>

                <ng-container *ngIf="pdfLoaded">
                    <div *ngFor="let field of model.fields; let i = index" 
                        [hidden]="!isFieldVisible(field) || (completed && (field.type === ContractFieldType.CHECKBOX || field.type === ContractFieldType.RADIO) && !(field.optionValue ? field.value === field.optionValue : (field.value === 'true' || field.value === 'checked')))"
                        class="field-overlay field-placeholder"
                        [class.field-filled]="field.value"
                        (click)="completed ? null : interactWithField(field)"
                        [style.z-index]="field.zIndex || (i + 1)"
                        [style.top.%]="field.y"
                        [style.left.%]="field.x"
                        [style.width]="field.wPct ? field.wPct + '%' : (field.width || 150) + 'px'"
                        [style.height]="field.hPct ? field.hPct + '%' : (field.height || 50) + 'px'"
                        [style.cursor]="completed ? 'default' : 'pointer'"
                        [class.field-overlay-active]="!completed"
                        class="pdf-field-overlay">
                        
                        <ng-container *ngIf="!field.value && field.type !== ContractFieldType.TEXT && field.type !== ContractFieldType.TEXTAREA && field.type !== ContractFieldType.NUMBER && field.type !== ContractFieldType.EMAIL && field.type !== ContractFieldType.PHONE && field.type !== ContractFieldType.DATE && field.type !== ContractFieldType.CHECKBOX && field.type !== ContractFieldType.RADIO && field.type !== ContractFieldType.DROPDOWN && field.type !== ContractFieldType.HEADERS && field.type !== ContractFieldType.IMAGE">
                            <span class="field-type-badge">
                                {{ field.type === ContractFieldType.SIGNATURE ? 'SIGNATURE' : (field.type === ContractFieldType.INITIALS ? 'INITIALS' : field.type) }}
                            </span>
                        </ng-container>
    
                        <ng-container *ngIf="field.value || (field.type !== ContractFieldType.SIGNATURE && field.type !== ContractFieldType.INITIALS)">
    
                            <img *ngIf="field.type === ContractFieldType.SIGNATURE || field.type === ContractFieldType.INITIALS || field.type === ContractFieldType.IMAGE" 
                                [src]="field.value" 
                                class="field-img-overlay">
                            
                            <input *ngIf="field.type === ContractFieldType.TEXT || field.type === ContractFieldType.EMAIL || field.type === ContractFieldType.PHONE"
                                [type]="field.type === ContractFieldType.EMAIL ? 'email' : (field.type === ContractFieldType.PHONE ? 'tel' : 'text')"
                                [(ngModel)]="field.value"
                                (blur)="completed ? null : saveProgress()"
                                (click)="$event.stopPropagation()"
                                [readonly]="completed"
                                style="width: 100%; height: 100%; border: none; background: transparent; padding: 5px; font-size: 12px; font-weight: 500;">

                            <textarea *ngIf="field.type === ContractFieldType.TEXTAREA"
                                [(ngModel)]="field.value"
                                (blur)="completed ? null : saveProgress()"
                                (click)="$event.stopPropagation()"
                                [readonly]="completed"
                                class="field-textarea-overlay"></textarea>

                            <input *ngIf="field.type === ContractFieldType.NUMBER"
                                type="text" inputmode="numeric"
                                [ngModel]="field.value || ''"
                                (ngModelChange)="field.value = $event"
                                (input)="completed ? null : onNumberInput(field, $event)"
                                (blur)="completed ? null : onNumberBlur(field)"
                                (click)="$event.stopPropagation()"
                                [readonly]="completed"
                                style="width: 100%; height: 100%; border: none; background: transparent; padding: 5px; font-size: 12px; font-weight: 500;">
    
                            <input *ngIf="field.type === ContractFieldType.DATE"
                                #dateInput
                                type="date"
                                [(ngModel)]="field.value"
                                (blur)="completed ? null : saveProgress()"
                                (click)="onDateClick(dateInput, $event)"
                                [readonly]="completed"
                                class="field-input-overlay">

                            <span *ngIf="field.type === ContractFieldType.DROPDOWN && completed"
                                style="width: 100%; height: 100%; display: flex; align-items: center; padding: 5px; font-size: 12px; font-weight: 500; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                                {{ field.value }}
                            </span>
                            <select *ngIf="field.type === ContractFieldType.DROPDOWN && !completed"
                                [(ngModel)]="field.value"
                                (change)="saveProgress()"
                                (click)="$event.stopPropagation()"
                                class="field-select-overlay">
                                <option *ngFor="let opt of field.options" [value]="opt">{{opt}}</option>
                            </select>

                                 <mat-icon *ngIf="field.type === ContractFieldType.CHECKBOX" 
                                    (click)="onCheckboxClick(field, $event)"
                                    [style.color]="(field.optionValue ? field.value === field.optionValue : field.value) ? 'var(--primary-color)' : '#ccc'"
                                    [style.cursor]="completed ? 'default' : 'pointer'"
                                    class="field-checkbox-icon">
                                    {{ (field.optionValue ? field.value === field.optionValue : field.value) ? (completed ? 'check' : 'check_box') : 'check_box_outline_blank' }}
                                </mat-icon>

                            <mat-icon *ngIf="field.type === ContractFieldType.RADIO" 
                                (click)="onRadioClick(field, $event)"
                                [style.color]="(field.optionValue ? field.value === field.optionValue : field.value) ? 'var(--primary-color)' : '#ccc'"
                                [style.cursor]="completed ? 'default' : 'pointer'"
                                class="field-radio-icon">
                                {{ (field.optionValue ? field.value === field.optionValue : field.value) ? (completed ? 'circle' : 'radio_button_checked') : 'radio_button_unchecked' }}
                            </mat-icon>

                            <div *ngIf="field.type === ContractFieldType.HEADERS" class="field-header-overlay">
                                {{ field.value || field.name }}
                            </div>

                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>


<ng-template #signForm>
    <mat-dialog-content>
        <div class="w-100" fxFlex fxLayout="column" fxLayoutAlign="space-between stretch" fxFlexAlign="start">
            <div class="title">
                <h1>{{ activeField?.type === ContractFieldType.INITIALS ? 'Draw your Initials' : 'Draw your Signature' }}</h1>
            </div>

            <div class="signature-pad-container signature-pad-wrapper">
                <canvas #signatureCanvas class="signature-canvas" (mousedown)="startDrawing($event)" (mousemove)="draw($event)" (mouseup)="stopDrawing()" (mouseleave)="stopDrawing()"
                (touchstart)="startDrawing($event)" (touchmove)="draw($event)" (touchend)="stopDrawing()"></canvas>
            </div>
            <div fxLayout="row" fxLayoutAlign="end center" class="mt-10">
                 <button mat-button (click)="clearSignature()">Clear</button>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-button (click)="dialogReference.close()">Cancel</button>
        <button mat-raised-button class="generic-save-btn" [disabled]="loading" (click)="insertSignature()">
            <span *ngIf="!loading">Accept</span>
            <span *ngIf="loading">Signing...</span>
        </button>
    </mat-dialog-actions>
</ng-template>
